import { getStrategyReasons } from './getStrategyReasons';
/**
 * Merges the given set of new strategies into the given instance.
 * This will ensure all adapter reasons are merged accordingly.
 */
export function mergeInstanceStrategies(instance, newStrategies) {
    const newInstance = Object.assign(Object.assign({}, instance), { 
        // merge the strategy-reason sets
        authenticationStrategies: Object.keys(newStrategies)
            .map((authenticationReason) => authenticationReason)
            .reduce((authenticationStrategies, authenticationReason) => {
            return Object.assign(Object.assign({}, authenticationStrategies), { [authenticationReason]: Array.from([
                    ... // use new strategies defined
                    (newStrategies[authenticationReason] ||
                        // or fall back to current instance strategies comes first
                        authenticationStrategies[authenticationReason] ||
                        // or fall back to an empty list
                        [])
                ]) });
        }, instance.authenticationStrategies) });
    // update all adapter reasons to have the ones specified in the new reasons
    // do not create new instances of adapters, or else the original data will be lost
    Object.values(newInstance.adapters).forEach((adapter) => {
        adapter.authenticationReasons = getStrategyReasons(newInstance.authenticationStrategies, adapter.strategy);
    });
    return newInstance;
}
